//STEP 1 - GUEST
window.getLogin = function (is_target = false) {
    if(is_target || $checkoutStep >= 1){
        $('#accordionCheckout-collapseLogin .accordion-body').load('index.php?route=checkout/login', function () {
            if(is_target){
                setCheckoutStep(1);
            }
        });
    }
}
//STEP 1 - GUEST - SAVE LOGIN
window.saveLogin = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/login/save', 'post', $(e.target).parents('form').serializeArray(), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('form'))
            }

            for (let i in json['error']) {
                const element = $('#input-login-' + i.replace('_', '-'));
                element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'][i] + '</div>')
            }
        }
    })
}

//STEP 2 - GUEST
window.getGuest = function (is_target = false) {
    if(is_target || $checkoutStep >= 2){
        $('#accordionCheckout-collapseGuest .accordion-body').load('index.php?route=checkout/guest', function () {
            $('input[name=\'company[existing]\']').on('change', function() {
                if ($(this).val() == 'false') {
                    $('.payment-address-company-existing').slideUp();
                    $('.payment-address-company-new').slideDown();
                    if(!manual_company_triggered) {
                        $('button[onclick*="saveGuest"]').hide();
                    }
                } else {
                    $('.payment-address-company-new').slideUp();
                    $('.payment-address-company-existing').slideDown();
                    $('button[onclick*="saveGuest"]').show();
                }
            });

            if(is_target){
                setCheckoutStep(2);
            }
        });
    }
}
//STEP 2 - GUEST - SAVE
window.saveGuest = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/guest/save', 'post', $(e.target).parents('form').serializeArray(), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }

            for (let i in json['error']) {
                const element = $('#input-payment-' + i.replace('_', '-'));
                element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'][i] + '</div>')
            }
        }else{
            if($('#accordionCheckout-collapseGuestShippingAddress').length) {
                getGuestShippingAddress(true);
            }else{
                getPaymentMethod(true);
            }
        }
    })
}

//STEP 3 - GUEST
window.getGuestShippingAddress = function (is_target = false) {
    if(is_target || $checkoutStep >= 3){
        $('#accordionCheckout-collapseGuestShippingAddress .accordion-body').load('index.php?route=checkout/guest_shipping', function () {
            if(is_target){
                setCheckoutStep(3);
                getGuest(false);
            }
        });
    }
}
//STEP 3 - GUEST - SAVE
window.saveGuestShippingAddress = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/guest_shipping/save', 'post', $(e.target).parents('form').serializeArray(), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }

            for (let i in json['error']) {
                const element = $('#input-shipping-' + i.replace('_', '-'));
                element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'][i] + '</div>')
            }
        }else{
            getShippingMethod(true);
        }
    })
}


//STEP 2 - CUSTOMER
window.getPaymentAddress = function (is_target = false) {
    if(is_target || $checkoutStep >= 2){
        $('#accordionCheckout-collapsePaymentAddress .accordion-body').load('index.php?route=checkout/payment_address', function () {

            $('input[name=\'payment_address\']').on('change', function() {
                if ($(this).val() == 'new') {
                    $('.payment-address-personal-existing').slideUp();
                    $('.payment-address-personal-new').slideDown();
                } else {
                    $('.payment-address-personal-new').slideUp();
                    $('.payment-address-personal-existing').slideDown();
                }
            });

            $('input[name=\'company[existing]\']').on('change', function() {
                if ($(this).val() == 'false') {
                    $('.payment-address-company-existing').slideUp();
                    $('.payment-address-company-new').slideDown();
                    if(!manual_company_triggered) {
                        $('button[onclick*="savePaymentAddress"]').hide();
                    }
                } else {
                    $('.payment-address-company-new').slideUp();
                    $('.payment-address-company-existing').slideDown();
                    $('button[onclick*="savePaymentAddress"]').show();
                }
            });

            if(is_target){
                setCheckoutStep(2);
            }
        });
    }
}
window.setPaymentAddressType = function (type) {
    if (type == 'personal') {
        $('.payment-address-company').slideUp();
        $('.payment-address-personal').slideDown();
        $('button[onclick*="savePaymentAddress"]').show();
        $('#company-enabled').val(0);
    } else {
        $('.payment-address-personal').slideUp();
        $('.payment-address-company').slideDown();
        $('#company-enabled').val(1);
    }
}
window.searchCompany = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=extension/module/company/search&json=1&company_vat=' + $('#input-payment-company-vat').val(), 'get', [], function () {
    }, function (json) {
        $(".se-pre-con").fadeOut("fast");
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');

        if(json['success']) {
            $('#input-payment-company-address').val(json['address_line_1']);
            $('#input-payment-company-name').val(json['name']);
            $('#input-payment-company-phone').val(json['phone']);
            $('#input-payment-company-reg').val(json['reg_no']);
            $('#input-payment-company-vat').val(json['vat_no']);
            $('#input-payment-company-country').val(json['country_id']).trigger('change');
            $('#input-payment-company-zone').val(json['zone_id']);
            $('#input-payment-company-city').val(json['city']);
            setCompanyManual();
        }else{
            const element = $('#input-payment-company-vat');
            element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'] + '</div>')
        }
    })
}
window.setCompanyManual = function (e){
    $('.company-field').show();
    if(e){
        $(e.target).hide();
    }
    manual_company_triggered = true;
    $('button[onclick*="savePaymentAddress"]').show();
}
//STEP 2 - CUSTOMER - SAVE
window.savePaymentAddress = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/payment_address/save', 'post', $(e.target).parents('form').serializeArray(), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }

            for (let i in json['error']) {
                const element = $('#input-payment-' + i.replace('_', '-'));
                element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'][i] + '</div>')
            }
        }else{
            if($('#accordionCheckout-collapseShippingAddress').length) {
                getShippingAddress(true);
            }else{
                getPaymentMethod(true);
            }
        }
    })
}

//STEP 3 - CUSTOMER
window.getShippingAddress = function (is_target = false) {
    if(is_target || $checkoutStep >= 3){
        $('#accordionCheckout-collapseShippingAddress .accordion-body').load('index.php?route=checkout/shipping_address', function () {

            $('input[name=\'shipping_address\']').on('change', function() {
                if ($(this).val() == 'new') {
                    $('.shipping-address-existing').slideUp();
                    $('.shipping-address-new').slideDown();
                } else {
                    $('.shipping-address-new').slideUp();
                    $('.shipping-address-existing').slideDown();
                }
            });

            if(is_target){
                setCheckoutStep(3);
                getPaymentAddress(false);
            }
        });
    }
}
//STEP 3 - CUSTOMER - SAVE
window.saveShippingAddress = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/shipping_address/save', 'post', $(e.target).parents('form').serializeArray(), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }

            for (let i in json['error']) {
                const element = $('#input-shipping-' + i.replace('_', '-'));
                element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error'][i] + '</div>')
            }
        }else{
            getShippingMethod(true);
        }
    })
}

//STEP 4
window.getShippingMethod = function (is_target = false) {
    if(is_target || $checkoutStep >= 4){
        $('#accordionCheckout-collapseShippingMethod .accordion-body').load('index.php?route=checkout/shipping_method', function () {
            if(is_target){
                setCheckoutStep(4);
                getShippingAddress(false);
            }
        });
    }
}
//STEP 4 - SAVE
window.saveShippingMethod = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/shipping_method/save', 'post', $('#accordionCheckout-collapseShippingMethod input[type=\'radio\']:checked, #accordionCheckout-collapseShippingMethod textarea'), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }
        }else{
            if (typeof sendE4Request !== 'undefined') {
                sendE4Request({
                    'event': 'add_shipping_info',
                    'code': $('#accordionCheckout-collapseShippingMethod input[type=\'radio\']:checked').val(),
                });
            }

            getPaymentMethod(true);
        }
    })
}

//STEP 5
window.getPaymentMethod = function (is_target = false) {
    let stepNumber;
    if($('#accordionCheckout-collapseShippingAddress').length || $('#accordionCheckout-collapseGuestShippingAddress').length) {
        stepNumber = 5;
    }else{
        stepNumber = 3;
    }

    if(is_target || $checkoutStep >= stepNumber){
        $('#accordionCheckout-collapsePaymentMethod .accordion-body').load('index.php?route=checkout/payment_method', function () {
            if(is_target){
                setCheckoutStep(stepNumber);
                getShippingMethod(false);
            }
        });
    }
}
//STEP 5 - SAVE
window.savePaymentMethod = function (e) {
    $(".se-pre-con").fadeIn("fast");
    customAjaxRequest('index.php?route=checkout/payment_method/save', 'post', $('#accordionCheckout-collapsePaymentMethod input[type=\'email\'], #accordionCheckout-collapsePaymentMethod input[type=\'radio\']:checked, #accordionCheckout-collapsePaymentMethod input[type=\'checkbox\']:checked, #accordionCheckout-collapsePaymentMethod textarea, #accordionCheckout-collapsePaymentMethod input[type=\'hidden\']'), function () {
    }, function (json) {
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $(".se-pre-con").fadeOut("fast");

        if (json['redirect']) {
            location = json['redirect'];
        } else if (json['error']) {
            if (json['error']['warning']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['warning'], $(e.target).parents('.row'))
            }
        }else{
            if (typeof sendE4Request !== 'undefined') {
                sendE4Request({
                    'event': 'add_payment_info',
                    'code': $('#accordionCheckout-collapsePaymentMethod input[type=\'email\'], #accordionCheckout-collapsePaymentMethod input[type=\'radio\']:checked').val(),
                });
            }

            getConfirm(true);
        }
    })
}

//STEP 6
window.getConfirm = function (is_target = false) {
    let stepNumber;
    if($('#accordionCheckout-collapseShippingAddress').length || $('#accordionCheckout-collapseGuestShippingAddress').length) {
        stepNumber = 6;
    }else{
        stepNumber = 4;
    }
    if(is_target || $checkoutStep >= stepNumber){
        $('#accordionCheckout-collapseConfirm .accordion-body').load('index.php?route=checkout/confirm', function () {
            if(is_target){
                setCheckoutStep(stepNumber);
                getPaymentMethod(false);
            }
        });
    }
}

window.setCheckoutStep = function (number) {
    $checkoutStep = number;
    let index = number - 1;
    if($is_logged) {
        index = index - 1;
    }

    $('[id*="accordionCheckout-collapse"]').each(function (i) {
        const el = $(this);
        const toggle = $('[data-bs-target="#' + el.attr('id') + '"]');
        let cc = bootstrap.Collapse.getInstance(this);
        if (cc === null) {
            cc = new bootstrap.Collapse(this, {
                toggle: false
            })
        }
        if (i == index) {
            cc.show();
            toggle.removeClass('pe-none');
            toggle.parents('.accordion-item').removeClass('step-finished');
        }else if (i < index) {
            cc.hide();
            toggle.removeClass('pe-none');
            toggle.parents('.accordion-item').addClass('step-finished');
        } else if (i > index) {
            cc.hide();
            toggle.addClass('pe-none');
            toggle.parents('.accordion-item').removeClass('step-finished');
            $(this).prev('.accordion-body').empty();
        }
    });

    $(".se-pre-con").fadeOut("fast");
}

$(document).ready(function () {
    if($('body').hasClass('checkout-checkout')){
        console.log($is_logged);
        if($is_logged !== 1) {
            getLogin(true);
        }else{
            getPaymentAddress(true);
        }
    }
});
